import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { MINIMUM_DAILY_DURATION_TO_SHOW_GAP } from '../../../../common/Constants'
import I18n from 'i18n'
import GenericPlaceholder from '../../../../common/GenericPlaceholder'
import { imputateGapsWithUndefinedRecords } from '../Utils'
import { initializeHighcharts } from '../../../../common/Utils'

const MultiDailyRestingHeartrateChart = props => {
  if (!props.dailyLogRows || props.dailyLogRows.length === 0) {
    return (
      <GenericPlaceholder title={I18n.t('components.dashboards.questionnaire.daily_resting_heartrate.title')} message={props.noDataMessage} />
    )
  }

  const allData = []
  for (const athleteSet of props.dailyLogRows) {
    const lineData = imputateGapsWithUndefinedRecords(athleteSet.data, MINIMUM_DAILY_DURATION_TO_SHOW_GAP, 1, 'resting_hr_moving_average').map(entry => {
      return {
        x: entry.date_only,
        y: entry.resting_hr_moving_average === undefined ? null : entry.resting_hr_moving_average,
        daily_date: entry.formatted_date,
        daily_hrrest: entry.resting_hr
      }
    })
    allData.push({
      type: 'line',
      data: lineData,
      name: `${athleteSet.athlete.first_name} ${athleteSet.athlete.last_name}`,
      tooltip: {
        headerFormat: '',
        pointFormat: I18n.t('components.dashboards.questionnaire.daily_resting_heartrate.scatter.tooltip')
      }
    })
  }
  initializeHighcharts(true)
  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          title: {
            text: I18n.t('components.dashboards.questionnaire.daily_resting_heartrate.title')
          },
          series: allData,
          plotOptions: {
            line: {
              marker: {
                enabled: false
              }
            }
          },
          legend: {
            enabled: true
          },
          yAxis: {
            title: {
              text: I18n.t('components.dashboards.questionnaire.daily_resting_heartrate.yaxis')
            },
            min: 30
          },
          xAxis: {
            title: {
              text: ''
            },
            type: 'datetime',
            dateTimeLabelFormats: {
              day: '%d %b'
            }
          }
        }}
      />
    </>
  )
}

export default MultiDailyRestingHeartrateChart
